import React, { Component } from 'react';
import styled from 'styled-components';
import AppLayout from 'Components/AppLayout/AppLayout';
import ModalStore from 'common/stores/modal.store';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';

import PageContainer from 'Components/PageContainer';

import Box from 'Components/Box';
import Text from 'Components/Text';
import Button from 'Components/Button';
import routes from 'common/constants/routing.constants';
import media from 'themes/media';
import NotFoundImage from '../../common/assets/images/404-image.png';

const Image = styled.div`
  max-width: 500px;

  ${media.lessThan('tablet')`
    max-width: 300px;
  `}

  img {
    width: 100%;
    height: auto;
  }
`;

class NotFound extends Component {
  render() {
    const { t } = this.props;
    ModalStore.push('newModal');
    return (
      <AppLayout>
        <PageContainer>
          <Box justify="center" flex mb={48} mt={48}>
            <Image>
              <img src={NotFoundImage} alt="404" />
            </Image>
          </Box>
          <Box mb={24} maxWidth={500} ml="auto" mr="auto">
            <Text align="center" mb={16} size="large" type="accent">
              {t('common.404.pageNotFound')}
            </Text>
            <Text align="center" size="large">
              {t('common.404.tryToChangeRequest')}
            </Text>
          </Box>
          <Box justify="center" flex>
            <Button
              inline
              type="primary"
              onClick={() => this.props.history.push(routes.trading.path)}
            >
              {t('common.404.goToTradingPage')}
            </Button>
          </Box>
        </PageContainer>
      </AppLayout>
    );
  }
}

export default withRouter(withTranslation()(NotFound));
